import React from "react";
import INotice from "./INotice";
import { classNames } from "@features/utils/reactFunctions";
import { toUpper } from "@features/utils/functions";

import * as style from "./NoticeStyle.module.scss";
import * as general from "../../styles/general.module.scss";

const Notice: React.FunctionComponent<INotice> = (props) => {
  return (
    <div
      className={classNames(
        general.appContainer,
        style.notice,
        props.additionalClassName,
        props.noDivider && style.noticeNoDivider,
        style[`notice${(props.color && toUpper(props.color)) || "Purple"}`]
      )}
      style={props.style}
    >
      {props.children}
    </div>
  );
};

export default Notice;
